import { React, PT, withRouter, connect } from '@gasbuddy/react';
import { Table, Dimmer, Loader, Segment, Grid, Dropdown, Button } from 'semantic-ui-react';
import qs from 'querystring';
import { RawDeetsModal } from '../../components/payments/rawDeetsModal';

import { Auth, Nav } from '../../components';
import { Action } from '../../reducers';
import { Role } from '../../roles';

const { useState, useCallback, useEffect, useMemo } = React;

const cardStatusOptions = [
  { key: 'all-cards', value: '', text: 'All cards' },
  { key: 'active-cards', value: 'active', text: 'Status: Active' },
  { key: 'terminated-cards', value: 'terminated', text: 'Status: Terminated' },
  { key: 'transfer-cards', value: 'transfer', text: 'Status: Transfer' },
  { key: 'suspended-cards', value: 'suspended', text: 'Status: Suspended' },
];

function WexCardsBase({
  loading = true,
  error,
  cards = [],
  page,
  totalPages,
  onLoadCards,
  history,
  location,
}) {
  const params = location && location.search ? qs.parse(location.search.substring(1)) : {};
  const curPage = params.page ? parseInt(params.page, 10) : page || 1;
  const curStatus = params.status ? params.status : '';
  const [selectedCardStatus, setSelectedCardStatus] = useState(curStatus);
  const [selectedPage, setSelectedPage] = useState(curPage);

  const updateUrl = (number, status) => {
    history.push(`/payments/cards?page=${number}&status=${status}`);
  };
  const handleCardStatusUpdate = useCallback((event, d) => {
    updateUrl(selectedPage, d.value);
    setSelectedCardStatus(d.value);
  }, []);

  const handlePageSelect = useCallback((number) => {
    updateUrl(number, selectedCardStatus);
    setSelectedPage(number);
  }, []);

  useEffect(() => {
    onLoadCards({
      url: '/payments/wex/cards',
      body: {
        page: selectedPage,
        cardStatus: selectedCardStatus,
      },
    });
  }, [selectedPage, selectedCardStatus]);

  const directional = useMemo(() => ({
    prev: page - 1 > 0 ? page - 1 : 1,
    next: page + 1,
  }), [page]);

  const currentStatus = cardStatusOptions.find(o => o.value === selectedCardStatus);

  return (
    <Auth forRoles={[Role.Superuser, Role.PaymentSupport]}>
      <Nav>
        <h1>Wex Cards</h1>

        <Dimmer.Dimmable dimmed={loading}>
          <Dimmer active={loading}>
            <Loader />
          </Dimmer>

          <Segment>
            <Grid columns="equal">
              <Grid.Column textAlign="left">
                <Dropdown
                  inline
                  options={cardStatusOptions}
                  defaultValue=""
                  text={currentStatus.text}
                  onChange={handleCardStatusUpdate}
                />
              </Grid.Column>
              <Grid.Column textAlign="center">
                {totalPages > 0 && `Page ${page} of ${totalPages}`}
                {error && `${error}`}
              </Grid.Column>
              <Grid.Column textAlign="right">
                {(page > 1) && <Button icon="left chevron" onClick={() => handlePageSelect(directional.prev)} content="Previous" />}
                {(totalPages > page) && <Button icon="right chevron" onClick={() => handlePageSelect(directional.next)} content="Next" />}
              </Grid.Column>
            </Grid>
          </Segment>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Account ID</Table.HeaderCell>
                <Table.HeaderCell>Card Number</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Status Reason</Table.HeaderCell>
                <Table.HeaderCell>View Raw</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {cards.map(card => (
                <Table.Row key={`${card.account_id}:${card.number}`}>
                  <Table.Cell><a href={`/identity/users/${card.account_id}`}>{card.account_id}</a></Table.Cell>
                  <Table.Cell>{card.number}</Table.Cell>
                  <Table.Cell>{card.status}</Table.Cell>
                  <Table.Cell>{card.status_reason}</Table.Cell>
                  <Table.Cell>
                    <RawDeetsModal data={card} />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>

            {totalPages > 0
            && (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan={5}>
                  <Grid columns="equal">
                    <Grid.Column textAlign="left">
                    </Grid.Column>
                    <Grid.Column textAlign="center">
                      {`Page ${page} of ${totalPages}`}
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                      {(page > 1) && <Button icon="left chevron" onClick={() => handlePageSelect(directional.prev)} content="Previous" /> }
                      {(totalPages > page) && <Button icon="right chevron" onClick={() => handlePageSelect(directional.next)} content="Next" /> }
                    </Grid.Column>
                  </Grid>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
            )}
          </Table>

        </Dimmer.Dimmable>
      </Nav>
    </Auth>
  );
}

WexCardsBase.propTypes = {
  // count: PT.number,
  error: PT.string,
  cards: PT.arrayOf(PT.object),
  loading: PT.bool,
  onLoadCards: PT.func,
  page: PT.number,
  totalPages: PT.number,
  history: PT.shape({ push: PT.func }).isRequired,
  location: PT.shape({
    params: PT.object,
  }).isRequired,
};

WexCardsBase.defaultProps = {
  // count: undefined,
  error: undefined,
  cards: undefined,
  loading: true,
  onLoadCards: () => {},
  page: undefined,
  totalPages: undefined,
};

function mapStateToProps({ wexcards }) {
  return {
    cards: wexcards.cards,
    count: wexcards.count,
    error: wexcards.error,
    loading: wexcards.loading,
    page: wexcards.page,
    totalPages: wexcards.totalPages,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadCards: payload => dispatch({
      type: Action.Payment.WexCards.LoadRequested,
      meta: { apiAction: true },
      payload,
    }),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WexCardsBase));
